  function removeLastStep(stepStatusArr) {
    let lastOne = stepStatusArr[stepStatusArr.length - 1]
    if (lastOne?.type === 'COMPLETE') {
      return stepStatusArr.filter(
        (step, index) => index !== stepStatusArr.length - 1,
      )
    }
    else {
      return stepStatusArr
    }
  }

  export default removeLastStep;